import *as React from 'react'
import { useEffect } from 'react'

import {Flow} from "../Dashboard/Flow"
import {Freq} from '../Dashboard/Frequence'

import "./time.scss"

export  function CoefBoard() {

    const [page, setPage] = React.useState(localStorage.getItem("souspage") || "flow")

    useEffect(() => {
        return () => {
            localStorage.removeItem("souspage")
        }
    }, [])

    useEffect(() => {
        localStorage.setItem("souspage", page)
    }, [page])

    return (
        <div className="template">
            <h1>Gestion des Coefficients</h1>
            <div className="buttons" id="flow-buttons">
                <button className={page=="flow"?"selected":""} onClick={()=>{setPage("flow")}}>Flow Distribution</button>
                <button className={page=="freq"?"selected":""} onClick={()=>{setPage("freq")}}>Fréquentation</button>
            </div>
            <div className="Horaires">
                {page=="flow"&&<Flow/>}
                {page=="freq"&&<Freq/>}
            </div>
            
        </div>
    )
}
